import { render } from "./UserAccountSummary.vue?vue&type=template&id=6dbd15c8"
import script from "./UserAccountSummary.vue?vue&type=script&lang=js"
export * from "./UserAccountSummary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__